import { render } from "./Item_Details.vue?vue&type=template&id=5c097d6a"
import script from "./Item_Details.vue?vue&type=script&lang=js"
export * from "./Item_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__